import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Document } from '@/api/model/interfaces';

export default class PackageKS2DocumentOdata extends OdataManager<PackageKS2Document> {}
